import {all, call, put, select, takeLatest} from 'redux-saga/effects';
import {
    selectPageName,
    selectUserHasInternet,
    selectUserHasMobilfunk,
    selectUserHasNone,
    selectUserHasTV,
    selectUserWantsInternet,
    selectUserWantsMobilfunk,
    selectUserWantsRedplus,
    selectUserWantsTV,
} from 'Container/Landingpage/selector';
import {
    ACCORDION_OPENED, FAQ_ACCORDION_TOGGLE,
    GET_OFFERS_SUCCESS,
    HOTLINE_BUTTON_CLICK,
    NOTIFICATION_HOTLINE_LINK_CLICK,
    OFFER_ALREADY_VISIBLE_ON_PAGELOAD,
    OFFER_GETS_VISIBLE,
} from 'Container/Landingpage/constant';
import {
    trackAccordionOpened,
    trackAccordionOpenedSuccess,
    trackApplyFilter,
    trackApplyFilterSuccess,
    trackFaqAccordionToggle,
    trackHotlineCTA_Click,
    trackPageView,
} from 'Container/Tracking/action';
import {
    selectAlreadyTrackedAccordion,
    selectAlreadyTrackedAppliedFilter,
    selectOpenedAccordionOfferId,
    selectHotlineNumber,
} from 'Container/Tracking/selector';
import { generateOfferId, IOfferKeyElements } from 'Container/Landingpage/helpers/offerDataHelper';

/**
 * Tracks the multipicker status when the first iffer-datails get
 * into viewport.
 */
export function* trackApplyFilterSaga () {

    const [has_mobilfunk, has_internet, has_tv, has_none, wants_mobilfunk, wants_internet, wants_tv, wants_redplus, alreadyTrackedAppliedFilter] =
        yield all([
            select(selectUserHasMobilfunk()),
            select(selectUserHasInternet()),
            select(selectUserHasTV()),
            select(selectUserHasNone()),
            select(selectUserWantsMobilfunk()),
            select(selectUserWantsInternet()),
            select(selectUserWantsTV()),
            select(selectUserWantsRedplus()),
            select(selectAlreadyTrackedAppliedFilter()),
        ]);
    const offerKeyElements: IOfferKeyElements = {
        has_mobilfunk, has_internet, has_tv, has_none, wants_mobilfunk, wants_internet, wants_tv, wants_redplus,
    };
    const offerId: string = generateOfferId(offerKeyElements);
    if (0 > alreadyTrackedAppliedFilter.indexOf(offerId)) {
        yield put(trackApplyFilter(offerId));
        yield put(trackApplyFilterSuccess(offerId));
    }

}

/**
 * Tracks, when the accordion (price details) is opened
 */
export function* trackAccordionOpenedSaga () {

    const [offerId, alreadyTrackedAccordion] =
        yield all([
            select(selectOpenedAccordionOfferId()),
            select(selectAlreadyTrackedAccordion()),
        ]);
    if (0 > alreadyTrackedAccordion.indexOf(offerId)) {
        yield put(trackAccordionOpened(offerId));
        yield put(trackAccordionOpenedSuccess(offerId));
    }

}

/**
 * Tracks, when the Hotline CTA in Offer-Price is clicked
 */
export function* trackHotlineClickSaga () {

    const phoneNumber = yield select(selectHotlineNumber());
    yield put(trackHotlineCTA_Click(phoneNumber));
}

/**
 * Tracks the pageview
 */
export function* trackPageViewSaga () {

    const pageName = yield (select(selectPageName()));
    const trackingData = {
        pageName,
    };

    yield put(trackPageView(trackingData));
}

/**
 * Tracks the pageview
 */
export function* trackFaqAccordionToggleSaga (accordion) {
    if (accordion.isOpen) {
        yield put(trackFaqAccordionToggle(accordion.accordionItemId));
    }
}

/**
 * Action Dispatcher for tracking actions
 *
 * @export {function} offersSaga
 */
export default function* trackingSaga () {
    yield takeLatest(OFFER_GETS_VISIBLE, trackApplyFilterSaga);
    yield takeLatest(OFFER_ALREADY_VISIBLE_ON_PAGELOAD, trackApplyFilterSaga);
    yield takeLatest(GET_OFFERS_SUCCESS, trackPageViewSaga);
    yield takeLatest(ACCORDION_OPENED, trackAccordionOpenedSaga);
    yield takeLatest(HOTLINE_BUTTON_CLICK, trackHotlineClickSaga);
    yield takeLatest(NOTIFICATION_HOTLINE_LINK_CLICK, trackHotlineClickSaga);
    yield takeLatest(FAQ_ACCORDION_TOGGLE, trackFaqAccordionToggleSaga);
}
